export const getInfiniteQueryNextPageParam = (
  lastPage: { hits: unknown[]; limit: number; estimatedTotalHits: number },
  allPages: unknown[],
) => {
  const nextPage =
    lastPage.hits.length === lastPage.limit ? allPages.length + 1 : undefined;

  if (nextPage === undefined) {
    return undefined;
  }

  const alreadyFetchedAllItems =
    allPages.length * lastPage.limit === lastPage.estimatedTotalHits;

  if (alreadyFetchedAllItems) {
    return undefined;
  }

  return nextPage;
};
